<template>
  <div>
    <table
      class="table table-striped table-bordered not-last-td m-0 table-data"
    >
      <thead>
        <tr class="cusmtom-thead-color">
          <th
            scope="col"
            rowspan="3"
            class="text-center p-2 m-0 custom-header-label sticky-header-1"
            style="min-width: 80px"
          >
            <strong>{{ $t('sigatoka.plant') }}</strong>
          </th>
          <th
            scope="col"
            rowspan="3"
            class="text-center p-2 m-0 custom-header-label sticky-header-1"
            style="min-width: 80px"
          >
            <strong>{{ $t('sigatoka.last_week') }}</strong>
          </th>
          <th
            scope="col"
            rowspan="3"
            class="text-center p-2 m-0 custom-header-label sticky-header-1"
            style="min-width: 80px"
          >
            <strong>{{ $t('sigatoka.actual_week') }}</strong>
          </th>
          <th
            v-for="(leaf, index) in bw_config"
            :key="'leaf.' + index"
            scope="col"
            :colspan="leaf.plus.length"
            class="text-center p-2 m-0 custom-header-label sticky-header-1"
          >
            <strong>{{ $t('sigatoka.leaf') }} {{ leaf.number }}</strong>
          </th>
        </tr>
        <tr class="cusmtom-thead-color">
          <template v-for="(leaf, index) in bw_config">
            <th
              v-for="(status, i) in leaf.status"
              :key="'leaf.' + index + '.status.' + i"
              class="text-center p-2 m-0 custom-header-label sticky-header-2"
            >
              {{ status }}
            </th>
          </template>
        </tr>
        <tr class="cusmtom-thead-color">
          <template v-for="(leaf, index) in bw_config">
            <th
              v-for="(plus, i) in leaf.plus"
              :key="'leaf.' + index + '.gross.' + i"
              class="text-center p-3 custom-header-label sticky-header-3"
            >
              {{ leaf.minus[i] }}/ {{ plus }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(_, index) in model.plants_count" :key="'plant.' + index">
          <td class="text-center">
            {{ index + 1 }}
          </td>
          <td class="text-center">
            {{ model.last_week[index] }}
          </td>
          <td class="text-center">
            {{ model.actual_week[index] }}
          </td>
          <template v-for="(leaf, leafIndex) in bw_config">
            <td
              v-for="number in leaf.status.length"
              :key="
                'plant.' + index + '.leaf.' + leafIndex + '.status.' + number
              "
            >
              <div class="d-flex justify-content-center">
                <a
                  class="btn-simple btn-link custom-margin-actions"
                  :class="getButtonClass(leafIndex, index, number)"
                >
                  <em
                    class="custom-size-fa-actions"
                    :class="getIconClass(leafIndex, index, number)"
                  ></em>
                </a>
              </div>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'bw-table',
  props: {
    model: {
      type: Object,
      default: {},
    },
    bw_config: {
      type: Array,
      default: [],
    },
  },
  methods: {
    getValue(leafIndex, index, number) {
      return this.model.leaves[leafIndex].value[index][number - 1];
    },
    getButtonClass(leafIndex, index, number) {
      const value = this.getValue(leafIndex, index, number);

      return {
        'btn-primary': value == 0 || value == null,
        'btn-warning': value === 'minus',
        'btn-success': value === 'plus',
      };
    },
    getIconClass(leafIndex, index, number) {
      const value = this.getValue(leafIndex, index, number);

      return {
        'fa fa-circle': value == 0 || value == null,
        'fa fa-minus': value === 'minus',
        'fa fa-plus': value === 'plus',
      };
    },
  },
};
</script>
